'use client';
import { ArrowCounterclockwise } from 'react-bootstrap-icons';
import Link from 'next/link';
import React from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

export function ResetSelectedFilters() {
  const pathName = usePathname();
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams ?? '');
  const query = params.get('q');
  const showParams = pathName?.includes('search');

  return (
    <Link href={(showParams ? `${pathName}?q=${query}` : pathName) ?? ''} className="text-decoration-none">
      <button className="btn bg-white medium border-0 lowercase" style={{ color: 'rgb(135, 135, 135)' }}>
        <ArrowCounterclockwise style={{ marginRight: '0.5rem', height: '1.2rem', marginBottom: '0.15rem' }} />
        <span>Reset</span>
      </button>
    </Link>
  );
}
